import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '@/lib/analytics';

/**
 * Fires a GA4 page_view event on every SPA navigation.
 *
 * Depends on `send_page_view: false` in the GA4 config (index.html)
 * so that the initial hard-load page view is also handled here,
 * giving us a single consistent source for all page views.
 */
export function usePageTracking(): void {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
}
